import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button } from '@mui/material';

import BOOKING_STAGES from '../../constants';
import useBookingFlow from '../../hooks/useBookingFlow';
import { BookingProps } from '../../types';
import Confirmation from '../Confirmation';
import Days from '../Days';
import ErrorNotice from '../ErrorNotice';
import Lessons from '../Lessons';
import MyBookings from '../MyBookings';
import Progress from '../Progress';
import Start from '../Start';
import Times from '../Times';
import Tutors from '../Tutors';

function AcademyReworkingBooking(props: BookingProps) {
	const { t } = useTranslation();
	const flow = useBookingFlow(
		props,
		t('academyReworkings.requestFailed'),
		t('academyReworkings.slotsChanged'),
	);
	const stageLabels = [
		t('academyReworkings.lessons'),
		t('academyReworkings.days'),
		t('academyReworkings.time'),
		t('academyReworkings.tutor'),
		t('academyReworkings.confirmation'),
	];
	const active = BOOKING_STAGES.indexOf(flow.step);
	return (
		<Box
			display="flex"
			flexDirection="column"
			gap="20px"
			sx={{
				width: '100%',
				minWidth: 0,
				maxWidth: '100%',
				overflowWrap: 'anywhere',
				'& > *': { minWidth: 0, maxWidth: '100%' },
			}}
		>
			{flow.step !== 'home' && (
				<Box>
					<Button onClick={flow.back} startIcon={<ArrowBackIcon />} disabled={flow.busy}>
						{t('academyReworkings.back')}
					</Button>
				</Box>
			)}
			{active >= 0 && <Progress active={active} labels={stageLabels} />}
			{flow.error && <ErrorNotice message={flow.error} onClose={() => flow.setError(null)} />}
			{flow.step === 'home' && <Start flow={flow} />}
			{flow.step === 'bookings' && (
				<MyBookings studentId={flow.studentId} onCancelled={flow.onBooked} />
			)}
			{flow.step === 'lessons' && <Lessons flow={flow} />}
			{flow.step === 'days' && <Days flow={flow} />}
			{flow.step === 'times' && <Times flow={flow} />}
			{flow.step === 'tutors' && <Tutors flow={flow} />}
			{flow.step === 'confirm' && <Confirmation flow={flow} />}
		</Box>
	);
}

export default observer(AcademyReworkingBooking);
